export const ERROR_TYPES = {
    MISS_REQUIRED_TOKEN: {
        code: 'tokenRequired',
        message:
            'Data is not available because required setting sessionId or accessToken is missing'
    },
    MISS_REQUIRED_DEP: {
        code: 'dependencyRequired',
        message: 'Data is not available because required dependency is missing'
    },
    EMPTY_INVESTMENT: {
        code: 'emptyInvestment',
        message: 'Data is not available because the investment is empty'
    },
    INVALID_INVESTMENT: {
        code: 'invalidInvestment',
        message: 'Data is not available because the investment is invalid'
    },
    INVALID_INVESTMENT_TYPE: {
        code: 'invalidInvestmentType',
        message:
            'Data is not available because the investment type is not supported'
    },
    NODATA: {
        code: 'noData',
        message: 'Data is not available'
    },
    SERVICE: {
        code: 'serviceError',
        message: 'Data is not available because there is a service error'
    }
};

export function getErrorMessage(errorCode) {
    for (let error in ERROR_TYPES) {
        if (ERROR_TYPES[error].code === errorCode) {
            return ERROR_TYPES[error].message;
        }
    }
    return '';
}
